import React from 'react';
import { Notification } from 'wix-style-react';
import { Text } from '../PageElements/Text';
import { useLocation } from 'react-router';
import { parseQueryString } from '../../../utils/locationUtils';

export const BranchNotification = () => {
  const location = useLocation();
  const getBranchName = () => {
    const queryObject = parseQueryString(location.search);
    return ` "${queryObject.branch}" `;
  };

  return (
    <Notification show theme="warning" type="sticky" zIndex={999999999999}>
      <Notification.TextLabel>
        <Text light weight="thin" dataHook="branch-notification-name">
          This is a draft of the
          <Text light weight="normal" tagName="span">
            {getBranchName()}
          </Text>
          branch.
        </Text>
      </Notification.TextLabel>
    </Notification>
  );
};
